import Img from "../img/step1.webp";
import Img2 from "../img/step2.webp";
import Img3 from "../img/step3.webp";
import Img4 from "../img/step4.webp";
import Img5 from "../img/step5.webp";

import Img6 from "../img/step6.webp";
import Img7 from "../img/step7.jpg";
import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataAccessKey = [
  {
    title: "Перейдите на страницу сообщества (паблика)",
    description:
      "Зайдите в ваш аккаунт ВКонтакте и откройте страницу сообщества, которое вы хотите подключить к API.",
    imgSrc: Img,
  },
  {
    title: "Откройте раздел управления сообществом",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В верхнем меню сообщества нажмите на кнопку «Управление».</li>
        <li>Откроется панель с настройками вашего сообщества.</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Найдите пункт «Работа с API» в правом боковом меню",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          Слева в боковом меню (или сверху, в зависимости от интерфейса)
          пролистайте вниз и выберите «Работа с API».
        </li>
        <li>
          Это раздел, где можно создать ключи доступа и настроить взаимодействие
          через API.
        </li>
      </ul>
    ),
    imgSrc: Img3,
  },
  {
    title: "Создайте ключ доступа",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В разделе «Работа с API» найдите кнопку «Создать ключ».</li>
        <li>
          Нажмите на неё, выберите необходимые разрешения для ключа (например,
          управление сообщениями, доступ к статистике и т.д.).
        </li>
        <li>Подтвердите создание ключа.</li>
      </ul>
    ),
    imgSrc: Img4,
  },
  {
    title: "Скопируйте ключ доступа и вставьте в поле ввода",
    description: (
      <ul className={styles.ulListContainer}>
        <li>После создания ключа он отобразится на экране.</li>
        <li>
          Скопируйте ключ (будьте осторожны, не делитесь им с другими лицами).
        </li>
        <li>Вставьте этот ключ в поле ввода.</li>
      </ul>
    ),
    imgSrc: Img5,
  },
];

export const stepsDataGroupId = [
  {
    title: "Перейдите на вкладку «Callback API»",
    description: "В разделе «Работа с API» выберите вкладку «Callback API».",
    imgSrc: Img6,
  },
  {
    title: "Найдите и скопируйте group_id",
    description: (
      <ul className={styles.ulListContainer}>
        <li>
          На странице «Callback API» найдите значение group_id. Обычно оно
          отображается рядом с основными параметрами группы.
        </li>
        <li>Скопируйте этот идентификатор.</li>
      </ul>
    ),
    imgSrc: Img7,
  },
];
